import {
  Box,
  ClickAwayListener,
  Stack,
  Modal as MuiModal,
} from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { ReactNode } from 'react';

export type ModalProps = {
  open: boolean;
  handleClickAway: () => void;
  children: ReactNode;
  meta?: () => ReactNode;
  title?: string;
  testId?: string;
  titleSx?: Record<string, unknown>;
  sx?: Record<string, unknown>;
};

export const Modal = ({
  open,
  handleClickAway,
  children,
  meta,
  title,
  testId,
  titleSx,
  sx,
}: ModalProps) => {
  return (
    <MuiModal
      data-testid={testId}
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        borderRadius: '5px',
      }}
    >
      <ClickAwayListener onClickAway={() => handleClickAway()}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '50vw',
            bgcolor: 'background.paper',
            boxShadow: 1,
            borderRadius: '5px',
            ...sx,
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            height={50}
            alignItems="center"
            sx={{
              color: 'white',
              backgroundColor: '#313F9F',
              p: '0 20px',
              borderTopLeftRadius: '5px',
              borderTopRightRadius: '5px',
              ...titleSx,
            }}
          >
            {title && <div>{title}</div>}
            {meta && meta()}
            <HighlightOffIcon
              sx={{
                '&:hover': { color: 'red' },
              }}
              onClick={() => handleClickAway()}
            />
          </Stack>
          {children}
        </Box>
      </ClickAwayListener>
    </MuiModal>
  );
};
